import React from 'react'
import DateRangePicker from 'react-bootstrap-daterangepicker'
import moment, { Moment } from 'moment'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-daterangepicker/daterangepicker.css'
import '../DateRange/dateRangePickerStyles.css'

import { CalendarIcon } from './CalendarIcon'
import { CalendarCheckIcon } from './CalendarCheckIcon'
import * as S from './StandardDateControl.styles'

type Props = {
  isSelected: boolean
  startDate: Moment
  endDate: Moment
  onApply: (startDate: Moment, endDate: Moment) => void
}

const formatCustomDateRange = (startDate: Moment, endDate: Moment) =>
  `${startDate.format('DD/MM/YYYY')} - ${endDate.format('DD/MM/YYYY')}`

export const CustomDateTab: React.FC<Props> = ({
  isSelected,
  startDate,
  endDate,
  onApply,
}) => {
  const handleApply = (_event: unknown, picker: { startDate: Moment; endDate: Moment }) => {
    onApply(picker.startDate, picker.endDate)
  }

  return (
    <DateRangePicker
      maxDate={moment().startOf('day')}
      startDate={startDate}
      endDate={endDate}
      onApply={handleApply}
      drops="auto"
    >
      <S.FrequencyButton
        type="button"
        isSelected={isSelected}
        $isCustomTab
        $isCustomSelected={isSelected}
      >
        <S.CustomButtonContent>
          {isSelected ? formatCustomDateRange(startDate, endDate) : 'Custom'}
          {isSelected ? (
            <CalendarCheckIcon width={16} height={16} />
          ) : (
            <CalendarIcon width={16} height={16} />
          )}
        </S.CustomButtonContent>
      </S.FrequencyButton>
    </DateRangePicker>
  )
}
